import axios from 'axios';

// Agar environment variable maujood hai to wo use karega, warna localhost (development ke liye)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

// Har request se pehle token check karein
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token; 
  }
  return config;
});

export default api;